"use client"

import { ArrowUp } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ArrowUpIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ArrowUpIcon = component(Icon)({ as: ArrowUp })
